<template>
  <div class="info-search">
    <h3>信息查询：</h3>
    <div class="search-group">
      <p class="label">请输入激活码，以查询对应的用户信息：</p>
      <div class="form-group">
        <el-input class="search-input" v-model="codeVl" size="small" />
        <div class="public-btn" @click="onSearchInfo()">查询</div>
      </div>
    </div>
    <div class="search-group">
      <p class="label">通过日语训练营账号查询绑定的标日账户：</p>
      <div class="form-group">
        <el-input class="search-input" v-model="accountVl" size="small" />
        <div class="public-btn" @click="onSearchAccount()">查询</div>
      </div>
    </div>

    <!-- 请输入激活码，以查询对应的用户信息： -->
    <el-dialog
      :visible.sync="infoModal"
      :footer="null"
      width="520px"
      custom-class="info-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="info-modal-main">
        <h4>您好，您的账户信息：</h4>
        <p class="info">用户名：{{ infoData.userName }}</p>
        <p class="info">手机号：{{ infoData.mobile }}</p>
        <p class="info">
          邮<span style="padding-left: 1em">箱</span>{{ infoData.email }}
        </p>
      </div>
    </el-dialog>

    <!-- 通过日语训练营账号查询绑定的标日账户： -->
    <el-dialog
      :visible.sync="accountModal"
      :footer="null"
      width="520px"
      custom-class="info-modal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="info-modal-main">
        <h4>您的日语训练账号为：</h4>
        <p class="info">手机号：{{ accountData.rxUserName }}</p>
        <h4>所绑定的标日账号为：</h4>
        <p class="info">用户名：{{ accountData.userName }}</p>
        <p class="info">手机号：{{ accountData.mobile }}</p>
        <p class="info">
          邮<span style="padding-left: 1em">箱</span>{{ accountData.email }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findUserByActivationCodeDB,
  findUserByRxUserNameDB,
} from "@/interface";
export default {
  name: "Info",
  components: {},
  props: {},
  data() {
    return {
      codeVl: "",
      accountVl: "",
      infoData: {},
      infoModal: false,
      accountData: {},
      accountModal: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onSearchInfo() {
      if (this.codeVl == "") {
        return this.$message.error("请输入激活码");
      }
      const params = {
        acticationCode: this.codeVl,
      };
      findUserByActivationCodeDB(params)
        .then((res) => {
          const data = this.$aes128Decrypt(res.data);
          this.infoData = data;
          this.infoModal = true;
        })
        .catch(() => {});
    },
    onSearchAccount() {
      if (this.accountVl == "") {
        return this.$message.error("请输入账号");
      }
      const params = {
        rxUserName: this.accountVl,
      };
      findUserByRxUserNameDB(params)
        .then((res) => {
          const data = this.$aes128Decrypt(res.data);
          this.accountData = data;
          this.accountModal = true;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.info-search {
  width: 1002px;
  margin: 0 auto;
  background: white;
  height: 360px;
  padding: 36px 180px;

  h3 {
    color: #090;
    font-size: 24px;
    line-height: 1.5em;
  }

  .search-group {
    .label {
      font-size: 18px;
      color: #666;
      line-height: 1.5em;
      margin-top: 20px;
    }
    .form-group {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .search-input {
        position: relative;
        top: 3px;
        width: 310px;
        height: 28px;
      }
    }
  }

  ::v-deep .info-modal {
    .el-dialog__body {
      padding: 0 40px 30px;
    }
    .info-modal-main {
      h4 {
        font-size: 18px;
        line-height: 2em;
      }
      .info {
        font-size: 16px;
        padding-left: 2em;
        line-height: 2em;
      }
    }
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .info-search {
    width: 100% !important;
    margin: 0 !important;
    padding: 20px !important;
    height: auto !important;
    min-height: 400px;

    h3 {
      font-size: 28px !important;
      text-align: center;
      margin-bottom: 20px;
    }

    .search-group {
      margin-bottom: 30px;

      .label {
        font-size: 20px !important;
        text-align: center;
        margin-top: 25px !important;
      }

      .form-group {
        flex-direction: column !important;
        align-items: center !important;
        margin-top: 15px !important;

        .search-input {
          width: 100% !important;
          max-width: 400px !important;
          height: 44px !important;
          margin-bottom: 15px !important;
          top: 0 !important;
        }

        .public-btn {
          width: 100% !important;
          max-width: 400px !important;
          height: 44px !important;
          line-height: 44px !important;
          font-size: 18px !important;
        }
      }
    }
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .info-search {
    padding: 15px !important;

    h3 {
      font-size: 24px !important;
    }

    .search-group {
      .label {
        font-size: 18px !important;
      }

      .form-group {
        .search-input {
          max-width: 100% !important;
        }

        .public-btn {
          max-width: 100% !important;
        }
      }
    }
  }

  // 移动端对话框优化
  ::v-deep .info-modal {
    width: 90% !important;
    margin: 5vh auto !important;

    .el-dialog__body {
      padding: 0 20px 20px !important;
    }

    .info-modal-main {
      h4 {
        font-size: 20px !important;
        text-align: center;
      }

      .info {
        font-size: 18px !important;
        text-align: center;
        padding-left: 0 !important;
      }
    }
  }
}

// 超小屏幕优化
@media (max-width: 480px) {
  .info-search {
    padding: 10px !important;

    h3 {
      font-size: 22px !important;
    }

    .search-group {
      .label {
        font-size: 16px !important;
      }

      .form-group {
        .search-input {
          height: 50px !important;
        }

        .public-btn {
          height: 50px !important;
          line-height: 50px !important;
          font-size: 16px !important;
        }
      }
    }
  }

  ::v-deep .info-modal {
    width: 95% !important;
    margin: 2vh auto !important;

    .el-dialog__body {
      padding: 0 15px 15px !important;
    }

    .info-modal-main {
      h4 {
        font-size: 18px !important;
      }

      .info {
        font-size: 16px !important;
      }
    }
  }
}

// 触摸设备优化
@media (hover: none) and (pointer: coarse) {
  .info-search {
    .search-group {
      .form-group {
        .public-btn {
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);

          &:active {
            transform: scale(0.98);
          }
        }
      }
    }
  }
}
</style>
